import { render, staticRenderFns } from "./discount-set.vue?vue&type=template&id=dba6bf62&scoped=true&"
import script from "./discount-set.vue?vue&type=script&lang=js&"
export * from "./discount-set.vue?vue&type=script&lang=js&"
import style0 from "./discount-set.vue?vue&type=style&index=0&id=dba6bf62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba6bf62",
  null
  
)

export default component.exports